import type { AnalyticsEventMap } from '../events'
import { trackAnalyticsEvent } from '../track'

type HowItWorksOpenedProperties = AnalyticsEventMap['how_it_works_opened']

/**
 * Fired when a user clicks the "How it works" (?) button in the Vaults or
 * Variable Rate Markets hero. `page` matches the table events' slugs, so
 * "how-it-works opens per browse page" is a breakdown by `page`. The
 * first-visit on-mount open of the same dialog is not tracked here, so this
 * counts deliberate clicks only.
 */
export function trackHowItWorksOpened(properties: HowItWorksOpenedProperties) {
  trackAnalyticsEvent('how_it_works_opened', properties)
}
